import React from 'react'
import Layout from '../../components/Layout'
import H1 from '../../components/H1'

export default function Page() {
  return (
    <Layout>
      <H1 title="Jobs" />
      {/* <p>
        No jobs listed at this time.
        The following positions are currently open to qualified seekers.
      </p> */}
        <ul>
        <li>
          <a target="_blank" rel="noopener" href="https://www.usajobs.gov/job/863892500">
          Air University - Chief Graduate Professional Education and Program Enhancement
          </a>
          <p>
            The Chief of Graduate Professional Education coordinates and aligns Air University's curricula across all graduate programs. This role advises schools and programs on curriculum development and supports academic program reviews. Key duties include advising on instructional design, curriculum delivery, instructional methodologies, briefing leaders on findings, drafting policy/guidance, and collaborating with multiple stakeholders to sustain high-quality, policy-compliant, accredited curriculum.
          </p>
        </li>
        <li>
          <a target="_blank" rel="noopener" href="https://www.usajobs.gov/job/865225300">
          Community College of the Air Force (CCAF) - Dean
          </a>
          <p>
            The primary purpose of this position is to serve as a first level supervisor, providing planning, directing, organizing, and exercising control over the Community College of the Air Force (CCAF). Serves as the key staff professional position, recognized as the top education and technical training expert consultant and senior education advisor on all academic matters relating to the Community College of the Air Force (CCAF), an organization within the Air Force Global College(AFGC) with Air Force-wide, sister-service, and DoD-level scope of operations. This position is responsible for all academic programs, policies and processes to ensure CCAF and AFGC mission success.
          </p>
        </li>
        <li>
          <a target="_blank" rel="noopener" href="https://jobs.auburn.edu/auburn-careers-home/jobs/8661?lang=en-us">
          Auburn University - Analyst, Institutional Studies
          </a>
          <p>
            The Office of Institutional Research is looking for an Analyst to provide demographic, analytical and other information about the University, its programs and its student population and assists in developing and maintaining data systems to support their analysis.
          </p>
        </li>
        </ul>
    </Layout>
  )
}
